import { render, staticRenderFns } from "./FlightsListSkeleton.vue?vue&type=template&id=17954b2d"
import script from "./FlightsListSkeleton.vue?vue&type=script&lang=js"
export * from "./FlightsListSkeleton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports